module.exports = __webpack_public_path__ + "img/lusterka-miniatura-dostawcze.3e5601b2.jpg";